/* 🤖 this file was generated by svg-to-ts */
export const siriusSpeedLow: {
  name: 'speed_low';
  data: string;
} = {
  name: 'speed_low',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.008 5.664a10.5 10.5 0 0 1 4.03-.789l-.003.75.002-.75C17.85 4.895 22.5 9.69 22.5 15.481v2.144a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5v-2.25a10.5 10.5 0 0 1 6.508-9.711Zm4.024.711a9 9 0 0 0-9.032 9v2.25h7.652L6.04 12.423a.75.75 0 0 1 1.122-.995l5.4 6.09a.75.75 0 0 1 .08.107H21v-2.144c0-4.986-4.003-9.089-8.968-9.106Z" fill="currentColor"/></svg>`
};
